var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0.920044L0.880079 5.95888V16.0366L9.99998 21.0754L19.1199 16.0366V5.95888L9.99998 0.920044Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1199 16.0352L9.99998 21.074L13.621 14.48L19.1199 16.0352Z",
    fill: "#F2B111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 21.0759L10.7146 14.9795L16.6951 8.88318L13.6206 14.4819L9.99964 21.0759Z",
    fill: "#FFD300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1199 16.0371L16.6954 8.88318L13.621 14.4819L19.1199 16.0371Z",
    fill: "#C88913"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1199 5.95813V16.0358L16.6954 8.8819L19.1199 5.95813Z",
    fill: "#FBB140"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 21.0807L10.7148 14.9844L5.7974 15.5131L9.99984 21.0807Z",
    fill: "#D59F0F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 21.0732L0.879859 16.0344L5.79731 15.5056L9.99976 21.0732Z",
    fill: "#B1890E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7148 14.9863L4.86443 9.38757L0.879951 16.0438L5.7974 15.515L10.7148 14.9863Z",
    fill: "#FFBA32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88027 16.0358V5.95813L4.86475 9.37956L0.88027 16.0358Z",
    fill: "#F5A318"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86423 9.38084L16.6951 8.88318L10.7146 14.9795L4.86423 9.38084Z",
    fill: "#FFEA54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86423 9.38275L16.6951 8.88509L8.76451 6.77002L4.86423 9.38275Z",
    fill: "#FFF597"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.879858 5.95889L9.99976 0.920044L8.76462 6.7676L4.86434 9.38033L0.879858 5.95889Z",
    fill: "#FEE24F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6951 8.88265L9.99966 0.920044L8.76452 6.76758L16.6951 8.88265Z",
    fill: "#FFD400"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6951 8.88265L9.99964 0.920044L15.72 4.0806L16.6951 8.88265Z",
    fill: "#FAF799"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6954 8.88336L19.1199 5.95958L15.7203 4.0813L16.6954 8.88336Z",
    fill: "#FDE34F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionStone);
export default __webpack_public_path__ + "static/media/Vision_Stone.b7d19cfee6c792cf3e16fac1affca7ca.svg";
export { ForwardRef as ReactComponent };